import { Component } from '@angular/core';

@Component({
    selector: 'app-tech-team',
    templateUrl: './tech-team.component.html',
    styleUrls: ['./tech-team.component.scss'],
    standalone: false
})
export class TechTeamComponent {

}
